<template>
    <span class="countrySelectInputComponent" v-if="!loading">
          <select class="form-control" @change="onChange($event.target.value)">
              <option value="">
                  {{placeholder}}
              </option>
            <option v-for="country in countries" :value="country.idCountry" :selected="isSelected(country)">
                {{ country.country }}
            </option>
        </select>
    </span>
</template>
<script>
    import axios from 'axios'

    export default {
        name: "CountrySelectInput",
        props: {
            selected: {
                default: null
            },
            placeholder: {
                type: String,
                default: 'Not selected'
            },
            language: {
                type: String,
                default: 'no'
            },
        },
        data: function () {
            return {
                loading: false,
                countries: [],
                selected_id: this.selected,
            }
        },
        methods: {
            onChange: function (selected_id) {
                this.selected_id = selected_id;
                this.$emit('select', this.selected_id);
            },
            isSelected: function (country) {
                return (country && this.selected_id) && (parseInt(country.idCountry) === parseInt(this.selected_id));
            },
            fetch: function () {
                this.loading = true;
                axios({
                    method: 'get',
                    url: 'data/countries?language_id=' + this.language,
                }).then(function (response) {
                    this.loading = false;
                    this.countries = response.data;
                }.bind(this))
                    .catch(e => {
                        console.warn(e);
                        this.loading = false;
                    });
            }
        },
        watch: {
            language: function () { //newVal, oldVal
                this.fetch();
            },
            selected: function (newVal, oldVal) {
                this.selected_id = newVal;
            }
        },
        created: function () {
            this.fetch();
        }
    }
</script>

<style scoped>
    select {
        appearance: menulist !important;
    }
</style>